module.exports = __webpack_public_path__ + "static/media/gritag_2.26d4e524.png";